
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id_utilisateur"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_debut"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_fin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"produit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statut"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pack"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recherche"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentsAnnonceur"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id_utilisateur"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id_utilisateur"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_debut"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_debut"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_fin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_fin"}}},{"kind":"Argument","name":{"kind":"Name","value":"produit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"produit"}}},{"kind":"Argument","name":{"kind":"Name","value":"statut"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statut"}}},{"kind":"Argument","name":{"kind":"Name","value":"pack"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pack"}}},{"kind":"Argument","name":{"kind":"Name","value":"recherche"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recherche"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consents"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consent_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk_bon_commande"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk_lead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk_categorie"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prenom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telephone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_collecte"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_lead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"heure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categorie"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pack"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk_pack"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type_flux"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"platform"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"platform_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"support_origin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"site_collecte"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phrase_optin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"consent_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expires_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"retrait"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_retrait"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canal_retrait"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"consumer_space_status"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1036}};
    doc.loc.source = {"body":"query ($id_utilisateur: ID, $date_debut: String, $date_fin: String, $produit: Int, $statut: String, $pack: String, $recherche: String) {\n    consentsAnnonceur(\n        id_utilisateur: $id_utilisateur,\n        date_debut: $date_debut,\n        date_fin: $date_fin,\n        produit: $produit,\n        statut: $statut,\n        pack: $pack,\n        recherche: $recherche\n    ){\n        consents{\n            consent_id\n            pk_bon_commande\n            pk_lead\n            pk_categorie\n            nom\n            prenom\n            email\n            telephone\n            date_collecte\n            date_lead\n            heure\n            categorie\n            pack\n            pk_pack\n            type_flux\n            platform\n            platform_label\n            support_origin\n            site_collecte\n            phrase_optin\n            consent_status\n            expires_at\n            duration_months\n            retrait\n            date_retrait\n            canal_retrait\n            consumer_space_status\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
